import FormattedMessage from 'I18n/components/FormattedMessage';
import { DEFAULT_VIEW_PATH } from 'email-management-lib/Shared/constants/frameworkTable';
import useIsUngatedForNewFrameworkFolders from 'email-management-lib/refactor/components/manage/frameworkTable/hooks/useIsUngatedForNewFrameworkFolders';
import { FolderOpenIcon } from 'foundations-assets';
import { Link } from 'foundations-components/transitional/components/Link';
import ListingLibMoveAssetsModal from 'framework-listing-lib/dialog/ListingLibMoveAssetsModal';
import useHasAllGates from 'messaging-management-lib/user/hooks/useHasAllGates';
import { useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
function BulkMoveButton({
  hasBulkWriteAccess,
  onClick,
  selectedViewPath,
  clearSelection,
  selectedObjectCount,
  selectedObjects,
  selectionMode
}) {
  const hasAllGates = useHasAllGates();
  const [shouldShowBulkMoveModal, setShouldShowBulkMoveModal] = useState(false);
  const isUngatedForFrameworkPortalsWithNoFolder = hasAllGates('Email:FrameworkPortalsWithNoFolder');
  const isUngatedForNewFrameworkFolders = useIsUngatedForNewFrameworkFolders();
  const onClickButton = () => {
    if (isUngatedForNewFrameworkFolders) {
      setShouldShowBulkMoveModal(true);
    } else {
      onClick();
    }
  };
  const onCloseModal = () => {
    setShouldShowBulkMoveModal(false);
    clearSelection();
  };
  if (selectedViewPath === DEFAULT_VIEW_PATH.ARCHIVED || !hasBulkWriteAccess || isUngatedForFrameworkPortalsWithNoFolder && !isUngatedForNewFrameworkFolders) {
    return null;
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(Link, {
      "data-test-id": "move-to-folder-link",
      onClick: onClickButton,
      children: [/*#__PURE__*/_jsx(FolderOpenIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "email-management.table.bulkActions.moveToFolder"
      })]
    }), shouldShowBulkMoveModal && /*#__PURE__*/_jsx(ListingLibMoveAssetsModal, {
      onClose: onCloseModal,
      selectedObjectOrObjects: selectedObjects,
      selectedObjectsCount: selectedObjectCount,
      selectionMode: selectionMode
    })]
  });
}
export default BulkMoveButton;